module.exports = __webpack_public_path__ + "static/media/лесная поляна с Еней.71f074b1.png";